import { PageHeader } from "../components/PageHeader";
import { EmptyState, ErrorState, Skeleton } from "../components/States";
import { currentRateCard } from "../lib/data";
import { aud, fmtPlainDate } from "../lib/format";
import { useAsync } from "../lib/useAsync";

/** Read-only view of the rate card in effect today. Directors edit rates in Supabase. */
export function RateCard() {
  const { data, error, loading, reload } = useAsync(currentRateCard);

  return (
    <section className="page" aria-labelledby="page-title">
      <PageHeader
        eyebrow="Pricing"
        title="Rate card"
        meta={data ? <>{data.name}. In effect from {fmtPlainDate(data.effective_from)}{data.effective_to ? ` to ${fmtPlainDate(data.effective_to)}` : ""}. Hourly rates per crew, excluding GST ({Math.round(Number(data.gst_rate) * 100)}%).</> : "Hourly rates per crew, excluding GST."}
      />
      {loading && !data && <Skeleton rows={6} columns={6} />}
      {error && <ErrorState message={error} onRetry={reload} />}
      {!loading && !error && !data && <EmptyState icon="dollar" title="No rate card in effect">Add a rate card with today inside its effective dates.</EmptyState>}
      {data && (
        <div className="stack">
          <div className="card card--table">
            <div className="card__head"><h2 className="card__title">Crew rates</h2><span className="muted small">Per hour, ex GST</span></div>
            <div className="table-wrap table-wrap--flat">
              <table className="table table--stack">
                <thead><tr><th scope="col">Crew</th><th scope="col" className="n">Day</th><th scope="col" className="n">Night</th><th scope="col" className="n">Weekend</th><th scope="col" className="n">Public holiday</th><th scope="col" className="n">Travel allowance</th></tr></thead>
                <tbody>
                  {data.rate_card_rows.map((r) => (
                    <tr key={r.crew_size}>
                      <td data-label="Crew" className="strong">{r.crew_size}-person</td>
                      <td data-label="Day" className="n">{aud(Number(r.day_rate))}</td>
                      <td data-label="Night" className="n">{aud(Number(r.night_rate))}</td>
                      <td data-label="Weekend" className="n">{aud(Number(r.weekend_rate))}</td>
                      <td data-label="Public holiday" className="n">{aud(Number(r.public_holiday_rate))}</td>
                      <td data-label="Travel" className="n">{aud(Number(r.travel_allowance))}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          {data.service_prices.length > 0 && (
            <div className="card card--table">
              <div className="card__head"><h2 className="card__title">Plans, permits and extras</h2></div>
              <table className="table table--stack">
                <thead><tr><th scope="col">Code</th><th scope="col">Service</th><th scope="col">Unit</th><th scope="col" className="n">Price ex GST</th><th scope="col">Notes</th></tr></thead>
                <tbody>
                  {data.service_prices.map((s) => (
                    <tr key={s.code}>
                      <td data-label="Code" className="mono strong">{s.code}</td>
                      <td data-label="Service">{s.description}</td>
                      <td data-label="Unit">{s.unit === "hour" ? "Per hour" : "Each"}{s.min_quantity ? <span className="sub">Min {Number(s.min_quantity)}</span> : null}</td>
                      <td data-label="Price" className="n strong">{aud(Number(s.price))}</td>
                      <td data-label="Notes" className="small">{s.notes ?? ""}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {data.notes && <p className="muted small">{data.notes}</p>}
        </div>
      )}
    </section>
  );
}
